import React from 'react';
import {Button} from 'reactstrap';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {ASSET_CATEGORY, DOCUMENT_TYPE, REQUEST_TYPE, SERVER_URL} from "../../shared/utils/Constants";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import * as XLSX from 'xlsx';
import {toast} from "react-toastify";
import BbProductService from "../../shared/service/BbProductService";
import HsmDocumentService from "../../shared/service/HsmDocumentService";

export default class InstallationInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            installationData: [],
            serviceRequestId: null,
            isServiceRequestStatusIsClosed: true,
        };
        this.fileInput = React.createRef();
        this.bbProductService = new BbProductService();
        this.hsmDocumentService = new HsmDocumentService();
    }

    setData = (data, requestType, pageMode, status) => {
        this.setState({serviceRequestId: data.id});
        fetch(SERVER_URL + 'serviceRequest/getInstallationInfoByRequestId/' + data.id, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json())
            .then(retVal => this.setState({installationData: retVal}))
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }
    
    getData = () => {
        return this.state.installationData;
    }

    downloadBBProductUploadedAcceptanceReport = () => {
        this.bbProductService.findByRequestTypeAndRequestId(REQUEST_TYPE.SERVICE_REQUEST, this.state.serviceRequestId).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response)) {
                try {
                    this.hsmDocumentService.findByObjectTypeAndObjectId(REQUEST_TYPE.BB_PRODUCT, response.id).then(response => {
                        if (!GeneralUtils.isNullOrEmpty(response)) {
                            response.forEach(element => {
                                if (element.documentType === 'INSTALLATION_FORMS') {
                                    this.hsmDocumentService.findDocumentPartsByDocumentId(element.documentId).then(
                                        files => {
                                            files.forEach(file => {
                                                if (file.id === undefined) {
                                                    toast.error('İmzalı kabul tutanağı bulunamadı.');
                                                } else {
                                                    var binaryString = window.atob(file.fileContent);
                                                    var binaryLen = binaryString.length;
                                                    var bytes = new Uint8Array(binaryLen);
                                                    for (var i = 0; i < binaryLen; i++) {
                                                        var ascii = binaryString.charCodeAt(i);
                                                        bytes[i] = ascii;
                                                    }
                                                    var blob = new Blob([bytes], {type: file.fileType});
                                                    var link = document.createElement('a');
                                                    link.href = window.URL.createObjectURL(blob);
                                                    link.download = file.fileName;
                                                    link.click();
                                                }
                                            })
                                        }
                                    )
                                }
                            })
                        } else {
                            toast.error('İmzalı kabul tutanağı bulunamadı.');
                        }
                    });
                } catch {
                    toast.error('İmzalı kabul tutanağı bulunamadı.');
                }

            } else {
                toast.error('İmzalı kabul tutanağı bulunamadı.');
            }
        });
    }

    downloadTemplate = () => {
        fetch(process.env.PUBLIC_URL + '/assets/kurulum_bilgileri_sablon.xlsx')
            .then(response => {
                return response.blob()
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'kurulum_bilgileri_sablon.xlsx';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            })
            .catch(error => {
                toast.error("Şablon indirilirken hata oluştu.");
            });
    }

    downloadAcceptanceReport = () => {
        fetch(SERVER_URL + 'serviceRequest/getAcceptanceReport/' + this.state.serviceRequestId, {
            headers: {
                'Authorization': localStorage.getItem("Authorization")
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'kabul_tutanagi.pdf';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            })
            .catch(error => {
                toast.error("Kabul tutanağı indirilirken hata oluştu.");
            });
    }

    handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, {type: 'array'});
            const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

            const requiredColumns = ['AKTİF/PASİF(A/P)', 'ÜRÜN CİNSİ', 'MARKA', 'MODEL', 'SERİ-NO', 'MAC-NO', 'KONUM-ODA NO','KULLANICI ADI', 'PAROLA','SSID ADI','ŞİFRE','WAN IP','TELEFON'];
            const headers = XLSX.utils.sheet_to_json(firstSheet, {header: 1})[0];

            const missingColumns = requiredColumns.filter(col => !headers.includes(col));
            if (missingColumns.length > 0) {
                toast.error("Yüklenilen excel dosyası hatalıdır.");
                return;
            }

            const jsonData = XLSX.utils.sheet_to_json(firstSheet);
            const mappedData = jsonData.map(row => ({
                status: row['AKTİF/PASİF(A/P)'],
                productType: row['ÜRÜN CİNSİ'],
                brand: row['MARKA'],
                model: row['MODEL'],
                quantity: row['MİKTAR'],
                serialNumber: row['SERİ-NO'],
                macNo: row['MAC-NO'],
                locationRoomNo: row['KONUM-ODA NO'],
                username: row['KULLANICI ADI'],
                keyword: row['PAROLA'],
                ssidName: row['SSID ADI'],
                password: row['ŞİFRE'],
                wanIp: row['WAN IP'],
                phone: row['TELEFON']
            }));

            this.setState({installationData: mappedData}, () => {
                fetch(SERVER_URL + 'serviceRequest/saveInstallationInfo/' + this.state.serviceRequestId, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("Authorization")
                    },
                    body: JSON.stringify(this.state.installationData)
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                    })
                    .then(() => {
                        toast.success("Kurulum bilgileri başarıyla kaydedildi.");
                    })
                    .catch(error => {
                        toast.error("Kurulum bilgileri kaydedilirken hata oluştu.");
                    });
            });


        };
        reader.readAsArrayBuffer(file);
    }

    render() {
        return (
            <div>
                <div className="d-flex justify-content-end mb-3">
                    <Button color="primary" className="mr-2" onClick={this.downloadTemplate}>Excel Şablon İndir</Button>
                    <input
                        type="file"
                        ref={this.fileInput}
                        style={{display: 'none'}}
                        accept=".xlsx,.xls"
                        onChange={this.handleFileUpload}
                    />
                    <Button color="primary" onClick={() => this.fileInput.current.click()}
                            disabled={!this.state.isServiceRequestStatusIsClosed}>Excel Yükle</Button>
                    <Button color="primary" className="mr-2" onClick={this.downloadAcceptanceReport}
                            disabled={this.state.isServiceRequestStatusIsClosed}>Kabul Tutanağını İndir</Button>
                    <Button color="primary" className="mr-2" onClick={this.downloadBBProductUploadedAcceptanceReport}>İmzalı
                        Kabul Tutanağını İndir</Button>
                </div>
                <DataTable value={this.state.installationData} emptyMessage="Kayıt Bulunamadı">
                    <Column field="productType" header="Cinsi"/>
                    <Column field="brand" header="Marka"/>
                    <Column field="model" header="Model"/>
                    <Column field="quantity" header="Miktar"/>
                    <Column field="serialNumber" header="Seri No"/>
                    <Column field="macNo" header="MAC No"/>
                    <Column field="locationRoomNo" header="Konum-Oda No"/>
                    <Column field="username" header="Kullanıcı Adı"/>
                    <Column field="keyword" header="Parola"/>
                    <Column field="ssidName" header="SSID Adı"/>
                    <Column field="password" header="Şifre"/>
                    <Column field="wanIp" header="WAN IP"/>
                    <Column field="phone" header="Telefon"/>
                </DataTable>
            </div>

        );
    }
}